import { render, staticRenderFns } from "./ApproveHistory.vue?vue&type=template&id=7b766cbc&scoped=true&"
import script from "./ApproveHistory.vue?vue&type=script&lang=js&"
export * from "./ApproveHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b766cbc",
  null
  
)

export default component.exports